import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import rootReducer from "./redux/reducers";
// import axios from "axios";
// import { generateCorrelationId } from "./utils/correlationId";
// import { getHeader } from "./api/headers";

// axios.defaults.headers.common["x-api-key"] = getHeader();

// axios.interceptors.request.use((config) => {
//   let newConfig = Object.assign({}, config);

//   newConfig.data.request.header.correlationId = generateCorrelationId();
//   const posvRefNumber = newConfig.data.request.payload.posvRefNumber;
//   if (!posvRefNumber) {
//     newConfig.data.request.payload.posvRefNumber = localStorage.getItem(
//       "posvRefNumber"
//     );
//     newConfig.data.request.payload.planCode = localStorage.getItem("planCode");
//   }
//   return newConfig;
// });

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const app = (
  <Provider store={store}>
    {" "}
    <App />
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
